<template>
  <div class="mt-component-form print-container">
    <!-- PC 레이아웃 (768px 이상) -->
    <div class="desktop-layout" v-show="!isMobile">
      <vs-row  v-if="isShowTitle">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5>
            <i class="dot"></i> {{title}}
          </h5>
        </vs-col>
      </vs-row>

      <div class="overflow-x-auto">
        <!-- 테이블 헤더 -->
        <div class="mt-4 grid row-header" :style="`grid-template-columns: minmax(200px, 1fr) ${headerWidthYes} ${headerWidthNo} ${headerWidthNa} ${isNote ? headerWidthNote : ''}`">
          <div class="row-header__item">{{getHeaderTitle}}</div>
          <div class="row-header__item">{{getHeaderYes}}</div>
          <div class="row-header__item">{{getHeaderNo}}</div>
          <div class="row-header__item" style="white-space: nowrap;">{{getHeaderNa}}</div>
          <div v-if="isNote" class="row-header__item">{{getHeaderNote}}</div>
        </div>


        <!-- 테이블 본문 영역 -->
        <div class="grid row-content__body-item"
             v-for="(rows, indexRows) in list" :key="indexRows"
             :style="{ gridTemplateColumns: `minmax(200px, 1fr) ${headerWidthYes} ${headerWidthNo} ${headerWidthNa} ${isNote ? headerWidthNote : ''}`,
           borderBottom: (indexRows === list.length - 1 ? '1px solid #cdcdcd' : '')}"
        >
          <!-- title 속성이 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
          <div v-if="rows.title && rows.title !== ''
              && (indexRows === 0 || list[indexRows].title !== list[indexRows - 1].title)"
               class="col-span-12 item-title border-bottom" :style="`background-color: ${rows.titleColor}`">
            <b>{{rows.title}}</b>
          </div>

          <!--      항목 구분-->
          <div v-if="rows.group" class="grid border-bottom" :style="'grid-template-columns: 100px 1fr'" :set="(groupData = rows.group)">
            <div v-if="indexRows==0 || (list[indexRows - 1].group != groupData)" class="border-right" style="display: flex;justify-content: center;align-items: center;background-color: #F9F9F9; white-space:pre-line" v-text="rows.group"></div>
            <div v-else></div>
            <div class="item-content">
              <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
              <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
            </div>
          </div>
          <!-- 항목 이름  -->
          <div v-else class="item-content border-bottom">
            <span v-if="isNotDotInLabel" class="row-title-nodot" style="white-space:pre-line" v-text="rows.label"></span>
            <span v-else class="row-title" style="white-space:pre-line" v-text="rows.label"></span>
          </div>

          <!-- YES -->
          <div class="item-box border-bottom">
            <template v-if="isPrint">
              <div class="item-box-check" v-if="rows.is_checked === 'Yes'" style="text-align: center;  align-self: center;">
                <vs-icon icon="check" size="small"  ></vs-icon>
              </div>
              <div v-else class="item-box-check">
              </div>
            </template>
            <vs-checkbox
              v-else
              class="item-box-check"
              style="padding-left: 5px;"
              :disabled="isReadonly"
              :checked="rows.is_checked === 'Yes'"
              @change="checkForm($event, rows.id, 'Yes')"
            ></vs-checkbox>
          </div>

          <!-- No -->
          <div class="item-box border-bottom">
            <template v-if="isPrint">
              <div class="item-box-check" v-if="rows.is_checked === 'No'" style="text-align: center;  align-self: center;">
                <vs-icon icon="check" size="small"  ></vs-icon>
              </div>
              <div v-else class="item-box-check">
              </div>
            </template>
            <vs-checkbox
              v-else
              class="item-box-check"
              :disabled="isReadonly"
              :checked="rows.is_checked === 'No'"
              style="margin-right: 0;padding-left: 5px;"
              @change="checkForm($event, rows.id, 'No')"
            ></vs-checkbox>
          </div>

          <!-- N/A -->
          <div class="item-box border-bottom">
            <template v-if="isPrint">
              <div class="item-box-check" v-if="rows.is_checked === 'N/A'" style="text-align: center;  align-self: center;">
                <vs-icon icon="check" size="small"  ></vs-icon>
              </div>
              <div v-else class="item-box-check">
              </div>
            </template>
            <vs-checkbox
              v-else
              class="item-box-check"
              style="padding-left: 5px;"
              :disabled="isReadonly"
              :checked="rows.is_checked === 'N/A'"
              @change="checkForm($event, rows.id, 'N/A')"
            ></vs-checkbox>
          </div>

          <!-- 비고 -->
          <div v-if="isNote" class="item-note border-right border-bottom">
            <span v-if="isPrint" class="print-input"> {{rows.note}} </span>
            <ml-input v-else class="w-full flex-1" v-model="rows.note" @change="updateRowNote($event, rows.id, rows.note)"  :readonly="isReadonly"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 모바일 레이아웃 (768px 미만) -->
    <div class="mobile-layout" v-show="isMobile">
      <!-- 모바일 헤더 -->
      <div v-if="isShowTitle" class="mobile-header">
        <h5 class="mobile-title"><i class="dot"></i> {{ title }}</h5>
      </div>

            <!-- 모바일 점검 리스트 -->
      <div class="mobile-inspect-container">
        <div v-for="(rows, indexRows) in list" :key="indexRows" class="mobile-item-wrapper">
          <!-- title 속성이 지정된 경우, 섹션 헤더로 표시 -->
          <div v-if="rows.title && rows.title !== '' && (indexRows === 0 || list[indexRows].title !== list[indexRows - 1].title)"
               class="mobile-section-header"
               :style="`background-color: ${rows.titleColor || '#f8f9fa'}`">
            <h6 class="section-title">{{ rows.title }}</h6>
          </div>

          <!-- 각 점검 아이템 카드 -->
          <div class="mobile-inspect-card">
            <!-- 그룹 정보 -->
            <div v-if="rows.group && (indexRows === 0 || list[indexRows - 1].group !== rows.group)" class="mobile-group-badge">
              {{ rows.group }}
            </div>

            <!-- 점검 내용 -->
            <div class="mobile-inspect-content">
              <div class="inspect-label">
                <span v-if="isNotDotInLabel" class="label-text-nodot">{{ rows.label }}</span>
                <span v-else class="label-text-dot">{{ rows.label }}</span>
              </div>

              <!-- 토글 버튼 그룹 -->
              <div class="mobile-toggle-group">
                <button
                  class="mobile-toggle-btn"
                  :class="{ active: rows.is_checked === 'Yes' }"
                  :disabled="isReadonly || isPrint"
                  @click="toggleCheck(rows.id, 'Yes')"
                >
                  {{ getHeaderYes }}
                </button>
                <button
                  class="mobile-toggle-btn"
                  :class="{ active: rows.is_checked === 'No' }"
                  :disabled="isReadonly || isPrint"
                  @click="toggleCheck(rows.id, 'No')"
                >
                  {{ getHeaderNo }}
                </button>
                <button
                  class="mobile-toggle-btn"
                  :class="{ active: rows.is_checked === 'N/A' }"
                  :disabled="isReadonly || isPrint"
                  @click="toggleCheck(rows.id, 'N/A')"
                >
                  {{ getHeaderNa }}
                </button>
              </div>

              <!-- 비고 -->
              <div v-if="isNote" class="mobile-note-field">
                <label class="note-label">{{ getHeaderNote }}</label>
                <div class="note-input-container">
                  <p v-if="isPrint" class="note-print-text">{{ rows.note }}</p>
                  <ml-input v-else v-model="rows.note" @change="updateRowNote($event, rows.id, rows.note)" :readonly="isReadonly" class="note-input" placeholder="비고를 입력하세요" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isBottomNote" class="flex items-center mt-4">
      <div class="label-text mr-4">{{ bottomNoteTitle }}</div>
      <p v-if="isPrint" class="w-full flex-1">{{ bottomNote }}</p>
      <ml-textarea
        v-else
        class="flex-1 w-full"
        rows="5"
        :readonly="isReadonly"
        v-model="bottomNote"
        @change="updateBottomNote()"
      />
    </div>

    <!-- footer 지정된 경우, 표시한다 (중복될 경우 무시한다) -->
    <div v-if="footer && footer !== ''" class="row-header__item justify-start">
      <b class="ml-2">{{footer}}</b>
    </div>

  </div>


</template>

<script>
import config from '../../public/config'
import {groupData} from "echarts/lib/util/model";
export default {
  name: 'TableInspect',
  props: {
    isPrint: Boolean,
    isReadonly: Boolean,
    /**
     * 테이블 상단에 동그라미(●) 제목을 표시할지 여부
     */
    isShowTitle: Boolean,
    /**
     * 가장 오른쪽 열에 "비고" 칸을 표시할지 여부
     * 은평 branch 에서는 "비고" 칸이 기본으로 노출된다
     */
    isNote: {
      type: Boolean,
      default: true,
    },
    title: String,
    list: Array,
    tableHeaderTitle: String,
    tableHeaderYes: String,
    tableHeaderNo: String,
    tableHeaderNa: String,
    tableHeaderNote: String,
    headerWidthYes: {
      type: String,
      default: '130px',
    },
    headerWidthNo: {
      type: String,
      default: '130px',
    },
    headerWidthNa: {
      type: String,
      default: '130px',
    },
    headerWidthNote: {
      type: String,
      default: 'minmax(200px, 388px)',
    },
    footer: String,
    isNotDotInLabel: Boolean,
    isBottomNote: {
      type: Boolean,
      default: false,
    },
    bottomNoteTitle : {
      type: String,
      default: '기타의견'
    },
    initBottomNote: {
      type: String,
      default: '',
    }
  },
  emits: ['update-list-check', 'update-note', 'update-bottom-note'],
  methods: {
    groupData,
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows - 1, text)
      } else {
        this.$emit('update-list-check', indexRows - 1, '')
      }
    },

    updateRowNote (value, indexRows, text) {
      this.$emit('update-note', indexRows - 1, text)
    },

    updateBottomNote() {
      this.$emit('update-bottom-note', this.bottomNote);
    },

    // 모바일용 토글 버튼 클릭 핸들러
    toggleCheck(rowId, value) {
      // 같은 값이면 해제, 다른 값이면 선택
      const currentRow = this.list.find(row => row.id === rowId);
      if (currentRow && currentRow.is_checked === value) {
        this.$emit('update-list-check', rowId - 1, '');
      } else {
        this.$emit('update-list-check', rowId - 1, value);
      }
    }
  },
  data () {
    return {
      hostname: config.HOST_NAME,
      bottomNote: this.initBottomNote,
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    getHeaderTitle () {
      if (this.tableHeaderTitle) return this.tableHeaderTitle
      else return '점검내용'
    },
    getHeaderYes () {
      if (this.tableHeaderYes) return this.tableHeaderYes
      else {
        return '양호'
      }
    },
    getHeaderNo () {
      if (this.tableHeaderNo) return this.tableHeaderNo
      else {
        return '미흡'
      }
    },
    getHeaderNa () {
      if (this.tableHeaderNa) return this.tableHeaderNa
      else {
        return '해당없음'
      }
    },
    getHeaderNote () {
      if (this.tableHeaderNote) return this.tableHeaderNote
      else return '비고(보완계획)'
    }
  },
  mounted() {
    // 화면 크기 변경 감지
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  background-color: $bg;
  border: $border;
  //border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: $border;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  &__title {
    background-color: $bg;
    height: 100%;
  }
}
.row-content__body-item {
  border-left: $border;

  .item-title {
    padding: 10px;
    border-right: $border;
  }

  .item-content {
    padding: 10px;
    align-self: center;
    color: #3c3c3c;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }

    .row-title {
      font-weight: 500;
      display: inline-flex;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }

    .row-title-nodot {
      font-weight: 500;
      display: inline-flex;
    }
  }
  .item-box {
    border-left: $border;
    //border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-box:last-child {
    border-right: $border;
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }

  .item-note {
    padding: 5px;
    border-left: $border;
    height: 100%;
    display: inline-flex;
    align-items: center;
  }
}


.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*체크박스 중앙 정렬을 위함.. scope style 내에서는 적용이 안되서 외부로 뺐음*/
.row-content__body-item .item-box .vs-checkbox {
  margin-right: 0;
}

// 모바일 레이아웃 스타일
@media (max-width: 767px) {
  .desktop-layout {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .mobile-layout {
    display: none !important;
  }
}

.mobile-layout {
  .mobile-header {
    margin-bottom: 16px;

    .mobile-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #007bff;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }

  .mobile-inspect-container {
    .mobile-section-header {
      margin: 16px 0 12px 0;
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #e9ecef;

      .section-title {
        font-size: 15px;
        font-weight: 700;
        margin: 0;
        color: #333;
      }
    }

    .mobile-inspect-card {
      background: white;
      border: 1px solid #e9ecef;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .mobile-group-badge {
        display: inline-block;
        background: #f8f9fa;
        color: #666;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 12px;
        border: 1px solid #e9ecef;
      }

      .mobile-inspect-content {
        .inspect-label {
          margin-bottom: 16px;
          line-height: 1.5;

          .label-text-dot {
            font-weight: 500;
            color: #333;
            display: inline-flex;

            &:before {
              content: "•";
              display: inline-block;
              width: 1em;
              margin-left: 1em;
            }
          }

          .label-text-nodot {
            font-weight: 500;
            color: #333;
            display: inline-flex;
          }
        }

        .mobile-toggle-group {
          display: flex;
          gap: 8px;
          margin-bottom: 16px;

          .mobile-toggle-btn {
            flex: 1;
            padding: 12px 8px;
            border: 2px solid #e9ecef;
            border-radius: 8px;
            background: white;
            color: #666;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            min-height: 44px;

            &:hover:not(:disabled) {
              border-color: rgba(var(--vs-primary), 1);
              color: rgba(var(--vs-primary), 1);
            }

            &.active {
              background: rgba(var(--vs-primary), 1);
              border-color: rgba(var(--vs-primary), 1);
              color: white;
              font-weight: 600;
            }

            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }
          }
        }

        .mobile-note-field {
          .note-label {
            display: block;
            font-size: 13px;
            font-weight: 600;
            color: #333;
            margin-bottom: 6px;
          }

          .note-input-container {
            .note-print-text {
              font-size: 14px;
              color: #555;
              line-height: 1.5;
              margin: 0;
              word-break: break-word;
            }

            .note-input {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
